var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard-right-status" }, [
    _c(
      "div",
      {
        staticClass: "dashboard-list-top",
        staticStyle: { position: "relative" }
      },
      [
        _c("div", { staticClass: "countdown-bar__wrapper" }, [
          _vm.showCountdownBar
            ? _c("div", {
                key: "countdownbar-" + _vm.countdownKey,
                staticClass: "countdown-bar animate",
                attrs: { id: "countdownBar" }
              })
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "container-fluid", style: { zIndex: 100 } }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-sm-7 col-md-8 col-8 left-side  header-controls"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "dashboard-list-header",
                    staticStyle: { "z-index": "700" }
                  },
                  [
                    _c("span", { staticClass: "listTitle" }, [
                      _c("h2", [
                        _vm._v("Media Calls "),
                        _vm.newMediaCallCount > 0
                          ? _c("span", { staticClass: "newMediaCallCount" }, [
                              _vm._v("+" + _vm._s(_vm.newMediaCallCount))
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _vm._m(0)
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c("div"),
    _vm._v(" "),
    _c("div", { staticClass: "dashboard-list-listing-wrapper" }, [
      _vm.isLoaded
        ? _c(
            "div",
            {
              class: _vm.dashboardListingClass(),
              attrs: { id: "dashboard-listing" }
            },
            [
              _vm.loading
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        left: "66.5%",
                        border: "none",
                        background: "transparent"
                      },
                      attrs: { id: "global-spinner" }
                    },
                    [_c("b-spinner", { attrs: { label: "Loading" } })],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.totalCount > 0
                ? _c(
                    "div",
                    {
                      staticClass: "dashboard-right-item clearfix",
                      staticStyle: { "z-index": "1" },
                      attrs: { id: "allList01" }
                    },
                    [
                      _c(
                        "swiper",
                        {
                          key: "swiper" + _vm.swiperKey,
                          ref: "swiper",
                          style: _vm.swiperCSS,
                          attrs: {
                            id: "swiper__media-calls",
                            speed: 1000,
                            direction: "vertical"
                          },
                          on: { "slide-change-start": _vm.slideChangeStart }
                        },
                        _vm._l(_vm.totalPage, function(n) {
                          return _c(
                            "div",
                            {
                              key: n,
                              staticClass: "swiper-row",
                              attrs: { id: "deList" + n }
                            },
                            [
                              _c(
                                "masonry",
                                {
                                  attrs: {
                                    cols: { default: 2, 1500: 1, 700: 1 },
                                    gutter: 5
                                  }
                                },
                                _vm._l(
                                  _vm.deliverablesArray.slice(
                                    (n - 1) * _vm.PageCountOfSwiper,
                                    n * _vm.PageCountOfSwiper
                                  ),
                                  function(deliverable, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: "deliverable" + index,
                                        staticClass: "dashboard-list-block",
                                        staticStyle: { "z-index": "-1" },
                                        style: { zIndex: 0 },
                                        attrs: { id: "de" + index }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex flex-row dbox-wrapper"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "dbox-left-side dleft-inner-wrap"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "top-row" },
                                                  [
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "data-status-items hide-mobile",
                                                          style: {
                                                            backgroundColor: _vm.getDeliverableStatusColor(
                                                              deliverable.status
                                                            )
                                                          }
                                                        },
                                                        [
                                                          _c("span", {}, [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getDeliverableStatusName(
                                                                  deliverable.status
                                                                )
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ],
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "data-items"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                                                    " +
                                                              _vm._s(
                                                                _vm.timeTitle(
                                                                  deliverable.all_completed
                                                                )
                                                              ) +
                                                              ": " +
                                                              _vm._s(
                                                                _vm.runningTime(
                                                                  deliverable
                                                                )
                                                              ) +
                                                              "\n                                                "
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "row listing-row"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-md-11 titles breakpoint__fix",
                                                        style: _vm.infoColStyle(
                                                          deliverable
                                                        )
                                                      },
                                                      [
                                                        deliverable.title !=
                                                        "Media call"
                                                          ? [
                                                              deliverable.title
                                                                .length < 45
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      class:
                                                                        "dashboard-list-title"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                    " +
                                                                          _vm._s(
                                                                            deliverable.title
                                                                          ) +
                                                                          "\n                                                "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _c(
                                                                    "div",
                                                                    {
                                                                      class:
                                                                        "dashboard-list-title"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                    " +
                                                                          _vm._s(
                                                                            deliverable.title
                                                                          ) +
                                                                          "\n                                                "
                                                                      )
                                                                    ]
                                                                  ),
                                                              _vm._v(" "),
                                                              _vm.showDepartment(
                                                                deliverable
                                                              )
                                                                ? _c("div", [
                                                                    deliverable
                                                                      ? _c(
                                                                          "div",
                                                                          _vm._l(
                                                                            deliverable.departments,
                                                                            function(
                                                                              department,
                                                                              index
                                                                            ) {
                                                                              return _c(
                                                                                "div",
                                                                                {
                                                                                  key:
                                                                                    "deliverable-modal-department-" +
                                                                                    department.id,
                                                                                  staticClass:
                                                                                    "department-title exclude-outside-click"
                                                                                },
                                                                                [
                                                                                  index >
                                                                                  0
                                                                                    ? _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticStyle: {
                                                                                            color:
                                                                                              "'var(--hover-grey)'"
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            " &"
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e(),
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        department.name
                                                                                      ) +
                                                                                      "\n                                                        "
                                                                                  )
                                                                                ]
                                                                              )
                                                                            }
                                                                          ),
                                                                          0
                                                                        )
                                                                      : _vm._e()
                                                                  ])
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _vm._.filter(
                                                                deliverable.customFields,
                                                                {
                                                                  field_key:
                                                                    "questions"
                                                                }
                                                              ).length == 0
                                                                ? _c(
                                                                    "div",
                                                                    [
                                                                      _c(
                                                                        "b-carousel",
                                                                        {
                                                                          attrs: {
                                                                            id:
                                                                              "index",
                                                                            "no-animation":
                                                                              "",
                                                                            interval: 8000,
                                                                            controls:
                                                                              "",
                                                                            "img-blank":
                                                                              ""
                                                                          },
                                                                          on: {
                                                                            "sliding-start":
                                                                              _vm.onSlideStart,
                                                                            "sliding-end":
                                                                              _vm.onSlideEnd
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "b-carousel-slide",
                                                                            {
                                                                              attrs: {
                                                                                caption:
                                                                                  "",
                                                                                "img-blank":
                                                                                  "",
                                                                                "img-alt":
                                                                                  "Blank image"
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  ref:
                                                                                    "totalSlide-" +
                                                                                    n +
                                                                                    "-" +
                                                                                    index,
                                                                                  refInFor: true,
                                                                                  attrs: {
                                                                                    id:
                                                                                      "totalSlide-" +
                                                                                      n +
                                                                                      "-" +
                                                                                      index
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " No questions have been entered. "
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _vm._l(
                                                                _vm._.filter(
                                                                  deliverable.customFields,
                                                                  {
                                                                    field_key:
                                                                      "questions"
                                                                  }
                                                                ),
                                                                function(
                                                                  field,
                                                                  index2
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key: index2
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "dashboard-list-content",
                                                                          domProps: {
                                                                            innerHTML: _vm._s(
                                                                              _vm.strippedContent(
                                                                                field.value,
                                                                                1
                                                                              )
                                                                            )
                                                                          }
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      false
                                                                        ? _c(
                                                                            "b-carousel",
                                                                            {
                                                                              attrs: {
                                                                                id:
                                                                                  "index",
                                                                                "no-animation":
                                                                                  "",
                                                                                interval: 8000,
                                                                                controls:
                                                                                  "",
                                                                                indicators:
                                                                                  "",
                                                                                "img-blank":
                                                                                  ""
                                                                              },
                                                                              on: {
                                                                                "sliding-start":
                                                                                  _vm.onSlideStart,
                                                                                "sliding-end":
                                                                                  _vm.onSlideEnd
                                                                              }
                                                                            },
                                                                            _vm._l(
                                                                              _vm.setSlidingArray(
                                                                                field.value
                                                                              ),
                                                                              function(
                                                                                nn
                                                                              ) {
                                                                                return _c(
                                                                                  "b-carousel-slide",
                                                                                  {
                                                                                    key: nn,
                                                                                    attrs: {
                                                                                      caption:
                                                                                        "",
                                                                                      "img-blank":
                                                                                        "",
                                                                                      "img-alt":
                                                                                        "Blank image"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        ref:
                                                                                          "totalSlide-" +
                                                                                          n +
                                                                                          "-" +
                                                                                          index,
                                                                                        refInFor: true,
                                                                                        attrs: {
                                                                                          id:
                                                                                            "totalSlide-" +
                                                                                            n +
                                                                                            "-" +
                                                                                            index,
                                                                                          "data-value": _vm.setSlidingArray(
                                                                                            field.value
                                                                                          )
                                                                                        },
                                                                                        domProps: {
                                                                                          innerHTML: _vm._s(
                                                                                            _vm.strippedContent(
                                                                                              field.value,
                                                                                              nn
                                                                                            )
                                                                                          )
                                                                                        }
                                                                                      }
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              }
                                                                            ),
                                                                            1
                                                                          )
                                                                        : _vm._e()
                                                                    ],
                                                                    1
                                                                  )
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              false
                                                                ? _c("div", {
                                                                    staticClass:
                                                                      "delete-bar",
                                                                    attrs: {
                                                                      title:
                                                                        "Delete"
                                                                    }
                                                                  })
                                                                : _vm._e()
                                                            ]
                                                          : [
                                                              _c(
                                                                "div",
                                                                {
                                                                  class:
                                                                    "dashboard-list-title"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                        \t    New media call being created.\n                                        \t"
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                      ],
                                                      2
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-md-1 infos"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex flex-row"
                                                          },
                                                          [
                                                            !deliverable.all_completed
                                                              ? _c(
                                                                  "DeliverableStatusOverview",
                                                                  {
                                                                    attrs: {
                                                                      deliverable: deliverable
                                                                    }
                                                                  }
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", {
                                                  staticClass: "bottom-row",
                                                  style: _vm.bottomRowStyle(
                                                    deliverable.tasks
                                                  )
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ],
                    1
                  )
                : _vm.totalCount == 0
                ? _c(
                    "div",
                    {
                      staticClass: "dashboard-right-item clearfix",
                      staticStyle: { "z-index": "1" },
                      attrs: { id: "allList01" }
                    },
                    [
                      _c("div", { staticClass: "dashboard-not-entry" }, [
                        _vm._v(
                          "\n                Recent media calls will be displayed here.\n        "
                        )
                      ])
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticClass: "dashboard-right-item clearfix",
                      staticStyle: { "z-index": "1" },
                      attrs: { id: "allList01" }
                    },
                    [
                      _c(
                        "masonry",
                        {
                          attrs: {
                            cols: { default: 2, 1500: 1, 700: 1 },
                            gutter: 5
                          }
                        },
                        _vm._l(_vm.deliverablesArray, function(
                          deliverable,
                          index
                        ) {
                          return _c(
                            "div",
                            {
                              key: "deliverable" + index,
                              staticClass: "dashboard-list-block",
                              staticStyle: { "z-index": "-1" },
                              style: { zIndex: 0 },
                              attrs: { id: "de" + index }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex flex-row dbox-wrapper" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dbox-left-side dleft-inner-wrap"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "top-row" },
                                        [
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "data-status-items hide-mobile",
                                                style: {
                                                  backgroundColor: _vm.getDeliverableStatusColor(
                                                    deliverable.status
                                                  )
                                                }
                                              },
                                              [
                                                _c("span", {}, [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getDeliverableStatusName(
                                                        deliverable.status
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ],
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "data-items" },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "\n                                                    " +
                                                    _vm._s(
                                                      _vm.timeTitle(
                                                        deliverable.all_completed
                                                      )
                                                    ) +
                                                    ": " +
                                                    _vm._s(
                                                      _vm.runningTime(
                                                        deliverable
                                                      )
                                                    ) +
                                                    "\n                                                "
                                                )
                                              ])
                                            ]
                                          )
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "row listing-row" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-md-11 titles breakpoint__fix",
                                              style: _vm.infoColStyle(
                                                deliverable
                                              )
                                            },
                                            [
                                              deliverable.title.length < 45
                                                ? _c(
                                                    "div",
                                                    {
                                                      class:
                                                        "dashboard-list-title"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                    " +
                                                          _vm._s(
                                                            deliverable.title
                                                          ) +
                                                          "\n                                                "
                                                      )
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      class:
                                                        "dashboard-list-title"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                    " +
                                                          _vm._s(
                                                            deliverable.title
                                                          ) +
                                                          "\n                                                "
                                                      )
                                                    ]
                                                  ),
                                              _vm._v(" "),
                                              _vm.showDepartment(deliverable)
                                                ? _c("div", [
                                                    deliverable
                                                      ? _c(
                                                          "div",
                                                          _vm._l(
                                                            deliverable.departments,
                                                            function(
                                                              department,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key:
                                                                    "deliverable-modal-department-" +
                                                                    department.id,
                                                                  staticClass:
                                                                    "department-title exclude-outside-click"
                                                                },
                                                                [
                                                                  index > 0
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticStyle: {
                                                                            color:
                                                                              "'var(--hover-grey)'"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " &"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        department.name
                                                                      ) +
                                                                      "\n                                                        "
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        )
                                                      : _vm._e()
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm._.filter(
                                                deliverable.customFields,
                                                { field_key: "questions" }
                                              ).length == 0
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "b-carousel",
                                                        {
                                                          attrs: {
                                                            id: "index",
                                                            "no-animation": "",
                                                            interval: 8000,
                                                            controls: "",
                                                            indicators: "",
                                                            "img-blank": ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "b-carousel-slide",
                                                            {
                                                              attrs: {
                                                                caption: "",
                                                                "img-blank": "",
                                                                "img-alt":
                                                                  "Blank image"
                                                              }
                                                            },
                                                            [
                                                              _c("div", [
                                                                _vm._v(
                                                                  " No questions have been entered. "
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm._.filter(
                                                  deliverable.customFields,
                                                  { field_key: "questions" }
                                                ),
                                                function(field, index) {
                                                  return _c(
                                                    "div",
                                                    { key: index },
                                                    [
                                                      _c(
                                                        "b-carousel",
                                                        {
                                                          attrs: {
                                                            id: "index",
                                                            "no-animation": "",
                                                            interval: 8000,
                                                            controls: "",
                                                            indicators: "",
                                                            "img-blank": ""
                                                          },
                                                          on: {
                                                            "sliding-start":
                                                              _vm.onSlideStart,
                                                            "sliding-end":
                                                              _vm.onSlideEnd
                                                          }
                                                        },
                                                        _vm._l(
                                                          _vm.setSlidingArray(
                                                            field.value
                                                          ),
                                                          function(n) {
                                                            return _c(
                                                              "b-carousel-slide",
                                                              {
                                                                key: n,
                                                                attrs: {
                                                                  caption: "",
                                                                  "img-blank":
                                                                    "",
                                                                  "img-alt":
                                                                    "Blank image"
                                                                }
                                                              },
                                                              [
                                                                _c("div", {
                                                                  domProps: {
                                                                    innerHTML: _vm._s(
                                                                      _vm.strippedContent(
                                                                        field.value,
                                                                        n
                                                                      )
                                                                    )
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              false
                                                ? _c("div", {
                                                    staticClass: "delete-bar",
                                                    attrs: { title: "Delete" }
                                                  })
                                                : _vm._e()
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-md-1 infos" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "d-flex flex-row"
                                                },
                                                [
                                                  !deliverable.all_completed
                                                    ? _c(
                                                        "DeliverableStatusOverview",
                                                        {
                                                          attrs: {
                                                            deliverable: deliverable
                                                          }
                                                        }
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass: "bottom-row",
                                        style: _vm.bottomRowStyle(
                                          deliverable.tasks
                                        )
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ],
                    1
                  )
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-sm-5 col-md-4 col-4 text-right right-side  header-controls"
      },
      [
        _c("div", { staticClass: "logo-user" }, [
          _c("div", { staticClass: "header__notification" }, [
            _c("div", { staticClass: "float-right" }, [
              _c("img", {
                staticClass: "logo",
                attrs: {
                  src: "/images/logo.svg?e0b2ae29f7aea7fcaf0153e097df8ceb"
                }
              })
            ])
          ])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }